module.exports = __webpack_public_path__ + "static/media/flick-basketball.ae846d80.jpg";